import React from 'react';

/**
 * Every tab's title: an icon chip and the tab's name, floating above the page
 * (never in a card, never with buttons beside it -- a tab's controls live in
 * its control card below, captioned with ControlGroup). `children` is for
 * STATUS next to the title only (e.g. the console's "Unpublished draft").
 */
export default function PageHeader({ icon: Icon, title, children }) {
  return (
    <div className="flex items-center gap-4 px-1">
      <div className="p-2.5 bg-white rounded-xl border border-slate-200 text-slate-500 shadow-sm">
        <Icon className="w-6 h-6" />
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <h2 className="text-xl font-bold text-slate-900 tracking-tight leading-none">{title}</h2>
        {children}
      </div>
    </div>
  );
}
